import { FullScreen as OLFullScreen } from 'ol/control'

// var FullScreen = /*@__PURE__*/(function (OLFullScreen) {
//     function FullScreen () {
//         OLFullScreen.apply(this, arguments);
//     }

//     if ( OLFullScreen ) FullScreen.__proto__ = OLFullScreen;
//     FullScreen.prototype = Object.create( OLFullScreen && OLFullScreen.prototype );
//     FullScreen.prototype.constructor = FullScreen;

//     /**
//     * @param {HTMLElement} element Target element
//     * @param {boolean} fullscreen True if fullscreen class name should be active
//     * @private
//     */
//     FullScreen.prototype.setClassName_ = function setClassName_ (element, fullscreen) {
//         var activeClassName = this.cssClassName_ + '-true';
//         var inactiveClassName = this.cssClassName_ + '-false';
//         var nextClassName = fullscreen ? activeClassName : inactiveClassName;
//         element.classList.remove(...activeClassName.split(' '));
//         element.classList.remove(...inactiveClassName.split(' '));
//         element.classList.add(...nextClassName.split(' '));
//     };

//     return FullScreen;
// }(OLFullScreen));

class FullScreen extends OLFullScreen {
    constructor(args) {
        super(args);
    }
}

/**
    * @param {HTMLElement} element Target element
    * @param {boolean} fullscreen True if fullscreen class name should be active
    * @private
    */
 FullScreen.prototype.setClassName_ = function setClassName_ (element, fullscreen) {
    var activeClassName = this.cssClassName_ + '-true';
    var inactiveClassName = this.cssClassName_ + '-false';
    var nextClassName = fullscreen ? activeClassName : inactiveClassName;
    element.classList.remove(...activeClassName.split(' '));
    element.classList.remove(...inactiveClassName.split(' '));
    element.classList.add(...nextClassName.split(' '));
};

export default FullScreen;